import { makeStyles, Theme } from '@material-ui/core';
import { white } from 'constants/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  card: {
    background: white,
    borderRadius: 20,
    padding: 32,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '32px 0',
  },
  divider: {
    width: '100%',
    margin: '16px 0 28px',
  },
  boldText: {
    fontFamily: 'Montserrat-Bold',
  },
  content: {
    width: '100%',
  },
  body: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  actions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '& button': {
      width: '100%',
      maxWidth: 160,
      margin: '0 10px',
    },
  },
  actionsGroup: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
    [theme.breakpoints.up('md')]: {
      marginTop: 0,
    },
  },
}));
